import React from 'react';
import s from './BackLoginLink.module.css';

export const BackLoginLink = () => (
    <a href={`${BASE_URL}/login`} className={s.forgotPasswordLink}>
        {i18next.t('BackLoginLink.return.text')}
    </a>
);
